import { GQT_COORDINATOR } from '@/constants';

export const getUserRole = (roles: string | Array<string> | undefined) => {
  if (!roles) {
    return '';
  }
  if (typeof roles === 'string') {
    return roles;
  }
  const roleRegex = /^GQT_.*$/;
  const validRoles = roles.filter((role: string) => roleRegex.test(role));
  if (validRoles.includes(GQT_COORDINATOR)) {
    return GQT_COORDINATOR;
  }

  return validRoles[0] ?? roles[0];
};
